<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <mart-detail-merchant [_showMartDetailMerchantSideBar]="showMartDetailMerchantSideBar" *ngIf="showMartDetailMerchantSideBar"
                         [martMerchantsComponent]="this" [_merchantId]="merchantId"
                         (changedShowMartDetailMerchantSideBarEmit)="changedShowMartDetailMerchantSideBarEmit($event)"></mart-detail-merchant>

    <!-- Table -->
    <p-table #xpressUsersGrid
             [columns]="cols"
             [value]="merchants"
             [lazy]="true"
             responsiveLayout="scroll" dataKey="Id"
             (onLazyLoad)="handleLazyLoad($event)"
             [paginator]="true"
             [(first)]="first"
             [rows]="rowsPerPage"
             [rowsPerPageOptions]="rowsPerPageOptions"
             [totalRecords]="totalRecords"
             [resizableColumns]="true"
             [columnResizeMode]="'expand'"
             [autoLayout]="true"
             [styleClass]="'p-datatable-striped'"
             [scrollable]="true"
             [scrollHeight]="'flex'"
             [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" class="search-input"
                           [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                           placeholder="Search..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of cols"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.disableSort"
                    pResizableColumn
                    [style.width]="col.width">
                    {{col.header}}
                    <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-merchant>
            <tr>
                <td class="ui-resizable-column">{{merchant.Id}}</td>
                <td class="ui-resizable-column">{{merchant.PartnerName}}</td>
                <td class="ui-resizable-column">{{merchant.XpressAgent}}</td>
                <td class="ui-resizable-column">{{merchant.CreatedAt}}</td>
                <td class="ui-resizable-column">{{merchant.ExpiryAt}}</td>
                <td class="ui-resizable-column">{{merchant.StatusText}}</td>
                <td class="ui-resizable-column">{{merchant.LastActive}}</td>
                <td>
                    <span class="action-icon-svg" (click)="openMartDetailMerchantSideBar(merchant)">
                        <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div *ngIf="merchants.length > 0" style="padding-left: 10px">
                Displaying {{first + 1}} - {{first + merchants.length}} of {{totalRecords}}
            </div>
        </ng-template>
    </p-table>
</div>

